// Offline resilience for workout submissions: if /workouts/{id}/end fails due
// to a network drop, the payload is stored here and retried automatically on
// the next app open or when the browser fires the 'online' event.
// The backend end endpoint is idempotent (atomic in_progress claim), so retries are safe.
import { endWorkout } from "./api";

const KEY = "nerdy_pending_ends";

function read() {
    try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
        return [];
    }
}

function write(list) {
    try {
        if (list.length) localStorage.setItem(KEY, JSON.stringify(list));
        else localStorage.removeItem(KEY);
    } catch {
        // storage blocked — non-fatal
    }
}

export function queuePendingEnd(workoutId, body) {
    const list = read();
    if (!list.some((item) => item.workout_id === workoutId)) {
        list.push({ workout_id: workoutId, body, queued_at: Date.now() });
        write(list);
    }
}

export async function flushPendingEnds() {
    const list = read();
    if (!list.length) return 0;
    const remaining = [];
    let synced = 0;
    for (const item of list) {
        try {
            await endWorkout(item.workout_id, item.body);
            synced += 1;
        } catch (e) {
            // Server responded (e.g. 400 "Already finalized") → drop it.
            // No response at all → still offline, keep it for the next flush.
            if (!e?.response) remaining.push(item);
        }
    }
    write(remaining);
    return synced;
}
